import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import FormDialog from "../FormDialog";
import { OutComeForm } from "../program/OutcomeForm";
import ProviderQualificationSearchModule from "../program/ProviderQualificationSearchModule";
import LinkDialog from "../LinkDialog";
import ProviderInterventionAudit from '../provider/ProviderInterventionAudit';
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'SAQAQualificationID', numeric: false, disablePadding: false, label: 'Qualification ID' },
    { id: 'SAQAQualificationTitle', numeric: false, disablePadding: false, label: 'Qualification Title' },
    { id: 'Credits', numeric: false, disablePadding: false, label: 'Credits', widthRation: .05 },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: false, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: false, label: 'Registration End Date' },
    { id: 'LastDateForEnrolment', numeric: false, disablePadding: false, label: 'Last Enrolment Date' },
    { id: 'LastDateForAchievement', numeric: false, disablePadding: false, label: 'Last Achievement Date' },
    { id: 'ProgramOutcome', numeric: false, disablePadding: false, label: 'Program Outcome' },
    { id: 'ModeOfDelivery', numeric: false, disablePadding: false, label: 'Mode Of Delivery' },
    { id: 'Specialisation', numeric: false, disablePadding: false, label: 'Specialisation' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

class ProviderQualificationSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedQualification: null,
            linkDialogOpen: false,
            formDialogOpen: false,
            auditDialogOpen: false,
            searchParameters: [{ Name: "ProviderID", Value: this.props.location.state.selection }],
            propmtOpen: false,
            promptTitle: "Remove Qualification from Provider",
            promptContent: "Are you sure you want to remove this qualification from the provider?",
            removeMessage: "",
            removeMessageStyle: "",
            selectedQualificationTitle: null,
            showTable: true

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: "Link existing Qualification to Provider", visible: this.props.menuPermissionItem.Add },
                        {
                            id: 'view', label: '', icon: 'UpdateIcon', tooltip: 'Update Outcome and Mode of Delivery',
                            disabled: utils.isNull(this.state.selectedQualification), visible: this.props.menuPermissionItem.Edit
                        },
                        {
                            id: 'audit', label: '', icon: 'AuditIcon', tooltip: 'View Record Audit Trail',
                            disabled: utils.isNull(this.state.selectedQualification)
                        },
                        {
                            id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove Qualification from Provider',
                            disabled: utils.isNull(this.state.selectedQualification), visible: this.props.menuPermissionItem.Delete
                        }]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {
                            id: 'unitStandards', label: '', tooltip: 'Link unit standard/s to the providers qualification', icon: 'AddIcon',
                            disabled: utils.isNull(this.state.selectedQualification), visible: this.props.menuPermissionItem.Add
                        }
                    ]
                }
            ]
        };

    }
    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/provider',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("view" === buttonId) {
            this.setState({ removeMessage: "" }, this.viewRecords());
        }
        else if ("audit" === buttonId) {
            this.setState({ auditDialogOpen: true, message: "" })
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, removeMessage: "" })
        }
        else if ("unitStandards" === buttonId) {
            this.props.history.push({
                pathname: '/providerQualificationUSSearch',
                state: {
                    ProviderID: this.props.location.state.selection,
                    ProviderQualificationID: this.state.selectedQualification,
                    QualificationTitle: this.state.selectedQualificationTitle,
                    providerName: this.props.location.state.providerName,
                    providerSDLNumber: this.props.location.state.providerSDLNumber
                }
            });
        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {

            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, auditDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedQualification: selection[0].Id, removeMessage: "", selectedQualificationTitle: selection[0].SAQAQualificationTitle });
        } else {
            this.setState({ selectedQualification: null, removeMessage: "", selectedQualificationTitle: null });
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("view", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("audit", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("unitStandards", selection === null || selection.length === 0);
    }

    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedQualification: null,
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    removeQualifications(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
            toolbarRef.current.setButtonDisabled("view", true);
            toolbarRef.current.setButtonDisabled("audit", true);
            toolbarRef.current.setButtonDisabled("unitStandards", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedQualification}&providerId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }

    viewRecords = () => {
        this.setState({ formDialogOpen: true })
    }


    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Provider > Qualifications " + (this.props.location.state.providerName !== null ? "> " + this.props.location.state.providerName + (this.props.location.state.providerSDLNumber !== null ? " - " + this.props.location.state.providerSDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.removeMessage} alertStyle={this.state.removeMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (
                        <EnhancedTable
                            headCells={headCells}
                            dataUrl={`api/sims/providerqualification/GetProviderQualifications`}
                            height="60vh"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />

                    )}
                </div>

                <FormDialog
                    open={this.state.formDialogOpen}
                    dialogTitle={"Update Outcome and Mode of Delivery"}
                    viewRef={this}
                    entityId={this.state.selectedQualification}
                    formRef={addFormRef}
                    saveUrl={"api/sims/providerqualification/UpdateQualificationModeAndDelivery"} usePut={true}
                    controllerName={"providerqualification"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <OutComeForm
                        ref={addFormRef}
                        id={this.state.selectedQualification}
                        controllerName={"providerqualification"}
                        dataURL='api/sims/providerqualification/GetFindQualificationMode'
                    />
                </FormDialog>

                <LinkDialog open={this.state.auditDialogOpen}
                    title={"Audit Trail"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={"Audit Trail"}
                    selectionId={this.props.location.state.selectedQualification}
                >

                    <ProviderInterventionAudit dataUrl={"api/sims/providerqualification/GetProviderQualificationAudit"}
                        multiSelect={false} showTitle={false}
                        Id={this.state.selectedQualification}
                    />
                </LinkDialog>

                <LinkDialog
                    open={this.state.linkDialogOpen}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link Qualifications to Provider > ${this.props.location.state.providerName} - ${this.props.location.state.providerSDLNumber}`}
                    linkName={"qualifications"} postUrl={"api/sims/providerqualification/LinkProviderQualification"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >
                    <ProviderQualificationSearchModule
                        dataUrl="api/sims/providerqualification/GetSearchLinkableQualifications"
                        mode="lookup"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.selection} programmeType="Q"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeQualifications("api/sims/providerqualification/RemoveProviderQualification") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ProviderQualificationSearch));
